"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var filebar_html_1 = __importDefault(require("./filebar.html"));
require("./filebar.less");
(function (module) {
    FilebarController.$inject = [
        '$scope',
        'pr.timezoneUtil',
        'pr.globalOptionsService',
        'pr.bulkFieldService',
        'pr.reportStatus'
    ];
    function FilebarController($scope, timezoneUtil, goService, bulkFieldService, reportStatus) {
        var fbCtrl = this;
        var isBulkFieldConfigPresent = !_.isEmpty(bulkFieldService.getConfig());
        angular.extend(fbCtrl, {
            onOpen: function (id) {
                fbCtrl.activeMenu = id;
            },
            onClose: function () {
                delete fbCtrl.activeMenu;
            },
            openMenu: function (evt, id) {
                var active = fbCtrl.activeMenu;
                if (active && active !== id) {
                    $(evt.target).mousedown();
                }
            },
            getTimezoneName: function () {
                return timezoneUtil.getTimezoneName(goService.getTimezone() || moment.tz.guess());
            },
            getTimezoneOffsetLabel: function () {
                return timezoneUtil.getTimezoneOffsetLabel(goService.getTimezone() || moment.tz.guess());
            },
            showBulkFieldDropdown: function () {
                return isBulkFieldConfigPresent;
            },
            getRelativeDateMessage: reportStatus.getRelativeDateMessage,
            getAbsoluteDateMessage: reportStatus.getAbsoluteDateMessage,
            isSaveError: reportStatus.anyFailedRequests
        });
    }
    module.component('prFilebar', {
        controller: FilebarController,
        controllerAs: 'fbCtrl',
        templateUrl: filebar_html_1.default,
        require: {
            bdyCtrl: '^^prBody'
        }
    });
}(angular.module('qualtrics.pr')));
